module.exports = __webpack_public_path__ + "static/media/appIcon.53fa7991.png";